import { render, staticRenderFns } from "./SalesBar.vue?vue&type=template&id=22869b0e&scoped=true&"
import script from "./SalesBar.vue?vue&type=script&lang=js&"
export * from "./SalesBar.vue?vue&type=script&lang=js&"
import style0 from "./SalesBar.vue?vue&type=style&index=0&id=22869b0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22869b0e",
  null
  
)

export default component.exports